<template>
  <v-app id="inspire">

    <v-navigation-drawer
      app
      temporary
      v-if="isLoggedIn"
      color="#EEEEEE"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-list dense>
        <v-list-item two-line v-if="isLoggedIn" class="mb-2">
          <v-list-item-avatar>
            <v-icon x-large>mdi-account</v-icon>
          </v-list-item-avatar>

          <v-list-item-content class="mt-3">
            <v-list-item-title>{{ currentUser.name }}</v-list-item-title>
            <v-list-item-subtitle>Usario en Sesión</v-list-item-subtitle>
            <div v-if="roleUser != 6" align="right" class="mt-1">
              <v-btn x-small color="primary" dark to="/perfil">Mi perfil</v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-group
          v-if="roleUser === 1 || roleUser === 2"
          prepend-icon="mdi-list"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-title>Catálogos</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in adminCatalogo"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-divider class="mb-3"></v-divider>
        <v-list-item
          v-if="roleUser != 6"
          v-for="(opcion, i) in capturistaCatalogo"
          :to="opcion.link"
          :key="opcion.text"
          link
        >
          <v-list-item-title>{{ opcion.text }}</v-list-item-title>
          <v-list-item-icon>
            <v-icon>{{ opcion.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" block color="grey darken-3 white--text">
            <v-icon>mdi-lock</v-icon> Salir</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!-- IMAGENES TAMAÑO GR -->
    <img
      v-if="path.includes('verifica')"
      src="@/assets/img/VERIFICA_CEDULASWEB.svg"
      class="hidden-sm-and-down"
      style="width:100%;height:auto"
    >
    <img
      v-else
      src="@/assets/img/CEDULASWEB.svg"
      class="hidden-sm-and-down"
      style="width:100%;height:auto"
    >
    <!-- IMAGENES TAMAÑO CH -->
    <img
      v-if="path.includes('verifica')"
      src="@/assets/img/VERIFICA_CEDULASMOV.svg"
      class="hidden-md-and-up"
      style="width:100%;height:auto"
    >
    <img
      v-else
      src="@/assets/img/CEDULASMOV.svg"
      class="hidden-md-and-up"
      style="width:100%;height:auto"
    >
    <template>
      <v-card class="overflow-hidden">
        <v-app-bar
          :clipped-left="$vuetify.breakpoint.lgAndUp"
          dark
          dense
          color="#373736"
        >
          <v-app-bar-nav-icon
            v-if="isLoggedIn"
            @click.stop="drawer = !drawer"
          />
          <v-btn class="hidden-sm-and-down" text to="/">
            <img src="@/assets/logo_nuevo.png" style="width:30px;height:31px">
          </v-btn>
          <v-btn v-if="isLoggedIn && roleUser!=6" class="hidden-sm-and-down ml-3" text to="/verificacion">Verificación
          </v-btn>
          <v-spacer />
          <v-list color="#373736" v-if="isLoggedIn" class="text-button">
            <v-list-item-icon class="d-none d-sm-flex">
              <v-icon left>mdi-account</v-icon>
              {{ currentUser.name }}
            </v-list-item-icon>
          </v-list>
          <v-btn icon v-if="isLoggedIn" @click="logout">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </v-app-bar>
      </v-card>
    </template>

    <v-content>
      <v-container fluid style="background-color:">
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer padless color="#373736" dark>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>STJ</strong>
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    source: String
  },
  data: () => ({
    // path: window.location.origin,
    dialog: false,
    drawer: null,
    adminCatalogo: [
      { icon: "mdi-account-group", text: "Usuarios", link: "/users" },
      { icon: "mdi-account-question", text: "Roles", link: "/roles" }
    ],
    capturistaCatalogo: [
      { icon: "mdi-account-details", text: "Cédulas", link: "/cedulas" }
    ]
  }),
  computed: {
    ...mapGetters(["roleUser", "isLoggedIn", "currentUser"]),
    path() {
      return this.$route.fullPath.toLowerCase();
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("LOGOUT").then(() => {
        this.$swal({
          title: "Ha cerrado Sesión ",
          icon: "success",
          timer: 1000
        });
        window.location = "/"
      }).catch(error => {
        this.$swal({
          title: "Error",
          text: "No se pudo Cerrar la Sesión Correctamente",
          icon: "error",
          confirmButtonText: "Aceptar"
        });
      });
    }
  }
};
</script>
